export const renderICD10 = (data) => {
  if (!data) {
    return <></>;
  }

  return data.map((diagnosis, index) => (
    <li className="ICD10-items" key={diagnosis.id || index}>
      {diagnosis.value}
    </li>
  ));
};
